export function getAbandonedHotelQuery(includeIsFavorite?: boolean) {
  return `
    ... on AbandonedHotel {
      isBooked
      hotelURL: url
      genericListingsUrl
      checkInDate
      checkOutDate
      numberOfAdults
      numberOfRooms
      hotelTotalPriceWithTaxesAndFeesAtAbandonment {
        amount
        currencyPrefix
      }
      hotelTotalPriceExcludingTaxes {
        amount
        currencyPrefix
      }
      priceDisplayRegulation
      dealType
      productType
      hotelInfo {
        ... on RtlHotel {
          __typename
          images(imageLimit: 1) {
            fastlyUrl
          }
          name
          starRating
          reviewInfo {
            reviewSummary {
              scores(scoreType: OVERALL) {
                score
              }
              total {
                count
              }
            }
          }
          neighborhood {
              name
              id
          }
          location {
            id
          }
          id
          ${includeIsFavorite ? 'isFavorite(cguid: $isFavoriteCguid)' : ''}
        }
        ... on SopqHotel {
          __typename
          images {
            fastlyUrl
          }
          name
          starRating
          neighborhood {
            name
          }
          location {
            name
          }
        }
        ... on AbandonedPriceBreakersHotel {
            __typename
            pricebreakerDescription
            pricebreakerLocation
        }
      }
    }
  `
}

export const abandonedRentalCarQuery = `
  ... on AbandonedRentalCar {
    isBooked
    carURL: url
    genericListingsUrl
    averageRating
    carExample
    carType
    imageURL: imageUrl
    isDropoffAtDifferentLocation
    numberOfReviews
    passengerCapacity
    pickupDateTime
    pickupLocation
    retailTypeCarCompanyDetails {
      brandImageURL: brandImageUrl
    }
    returnDateTime
    returnLocation
  }
`

export const abandonedFlightQuery = `
  ... on AbandonedFlight {
    flightURL: url
    genericListingsUrl
    tripType
    dealType
    isBooked
    numberOfAdults
    numberOfChildren
    numberOfLapInfants
    originDestinationInfo {
      travelStartDateTime
      originAirportInfo {
        city
        code
        country
        name
        state
      }
      destinationAirportInfo {
        city
        code
        country
        name
        state
      }
      flightPath {
        originAirportCode
        destAirportCode
        travelDateTime
      }
      ... on RoundTripInfo {
        travelEndDateTime
      }
      ... on MultiDestinationInfo {
        travelEndDateTime
      }
    }
  }           
`

export function getAbandonedPackageQuery(includeIsFavorite?: boolean) {
  const hotelFragment = getAbandonedHotelQuery(includeIsFavorite)
  return `
    ... on AbandonedPackage {
      __typename
      isBooked
      productType
      packageType
      creationDateTime
      totalChargeAmount
      frequency
      hotelSelections {
        ${hotelFragment}
      }
      airSelections {
        ${abandonedFlightQuery}
      }
      rcSelections {
        ${abandonedRentalCarQuery}
      }
    }
  `
}
